import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import MarketsIndex from "@/pages/MarketsIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/markets/")({
  head: () => ({
    meta: [
      { title: "Betting Market Predictions: BTTS, Over 2.5 | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["overUnder", "btts", "doubleChance"] }).meta },
      { name: "description", content: "Football predictions organised by betting market. Choose the bet type that fits your bankroll — we'll show you where the data actually agrees." },
      { property: "og:title", content: "Betting Market Predictions: BTTS, Over 2.5 | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Football predictions organised by betting market. Choose the bet type that fits your bankroll — we'll show you where the data actually agrees." },
      { name: "twitter:title", content: "Betting Market Predictions: BTTS, Over 2.5 | Statlign" },
      { name: "twitter:description", content: "Football predictions organised by betting market. Choose the bet type that fits your bankroll — we'll show you where the data actually agrees." },
    ],
  }),
  component: () => (
    <MainLayout>
      <MarketsIndex />
    </MainLayout>
  ),
});
